<template>
    <div class="content mt20">
        <div class="account-content bgfff">
            <matrixMenu></matrixMenu>
        </div>
        <div class="bgfff mt20">
            <h1 class="title">文章发布</h1>
            <div class="clearfix">
                <div class="article-finish ac">
                    <div class="article-fp mt30">
                        <i class="icons sucess-icon"></i>
                        <p class="color-gray mt10">发布完成！</p>
                    </div>
                    <div class="btn-div mt50 article-return">
                        <span class="color-gray">5s后自动返回</span>
                        <button class="btn btn-blue ml20">返回</button>
                    </div>
                </div>
            </div>
        </div>
  	</div>
</template>
<script>
import matrixMenu from './matrixMenu.vue';
export default {
    components:{matrixMenu},
    data() {
        return {
           
        }
    },
    mounted() {
		let that = this;
    },
    created() {
		
    },
    methods: {
       
       
	}
}
</script>



// WEBPACK FOOTER //
// src/page/materialCenter/matrixArticleFinish.vue